import React, {useEffect} from 'react';
import Main from "../../modules/main/main";
import usePermissions from "../../services/auth/usePermissions";
import useUser from "../../services/auth/useUser";
import {useNavigate} from "react-router-dom";
import {Link} from "react-router-dom";

function Admin() {
    const navigate = useNavigate();
    const [, userIs] = usePermissions();
    const user = useUser();
    const breadcrumbs = [
        {"link": "/", "name": "Admin", "active": true}
    ];

    useEffect(() => {
        // Check if user is Super Admin
        const isSuperAdmin = userIs('super-admin') || 
                            (user && user.user_permissions && user.user_permissions.length > 0 && 
                             user.user_permissions[0].slug === 'super-admin');
        
        if (!isSuperAdmin) {
            navigate('/dashboard');
            return;
        }
    }, [userIs, user, navigate]);

    // Check if user is Super Admin
    const isSuperAdmin = userIs('super-admin') || 
                        (user && user.user_permissions && user.user_permissions.length > 0 && 
                         user.user_permissions[0].slug === 'super-admin');

    if (!isSuperAdmin) {
        return null; // Don't render anything if not Super Admin
    }

    return (
        <Main title="Super Admin Dashboard" breadcrumbs={breadcrumbs} loading={false}>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                <i className="fas fa-shield-alt mr-2"></i>
                                Super Admin Control Panel
                            </h3>
                        </div>
                        <div className="card-body">
                            <p className="lead">Welcome to the Super Admin dashboard. This page is only accessible to Super Admin users.</p>
                            
                            <div className="row mt-4">
                                <div className="col-md-4 mb-3">
                                    <div className="card bg-primary text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-users mr-2"></i>
                                                User Management
                                            </h5>
                                            <p className="card-text">Manage users, roles, and permissions</p>
                                            <div className="mt-3">
                                                <Link to="/users" className="btn btn-light btn-sm mr-2">
                                                    <i className="fas fa-users mr-1"></i>
                                                    Users
                                                </Link>
                                                <Link to="/roles" className="btn btn-light btn-sm mr-2">
                                                    <i className="fas fa-user-tag mr-1"></i>
                                                    Roles
                                                </Link>
                                                <Link to="/permissions" className="btn btn-light btn-sm">
                                                    <i className="fas fa-key mr-1"></i>
                                                    Permissions
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <div className="card bg-success text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-file-alt mr-2"></i>
                                                Form Management
                                            </h5>
                                            <p className="card-text">Create and manage dynamic forms</p>
                                            <div className="mt-3">
                                                <Link to="/forms" className="btn btn-light btn-sm">
                                                    <i className="fas fa-file-alt mr-1"></i>
                                                    Forms Builder
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <div className="card bg-info text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-cog mr-2"></i>
                                                System Settings
                                            </h5>
                                            <p className="card-text">Configure system settings and preferences</p>
                                            <div className="mt-3">
                                                <Link to="/settings" className="btn btn-light btn-sm">
                                                    <i className="fas fa-cog mr-1"></i>
                                                    Settings
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <div className="card bg-warning text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-chart-bar mr-2"></i>
                                                Reports & Analytics
                                            </h5>
                                            <p className="card-text">View system reports and analytics</p>
                                            <div className="mt-3">
                                                <Link to="/reports" className="btn btn-light btn-sm">
                                                    <i className="fas fa-chart-bar mr-1"></i>
                                                    Reports
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <div className="card bg-danger text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-clipboard-list mr-2"></i>
                                                Applications
                                            </h5>
                                            <p className="card-text">Review and manage applications</p>
                                            <div className="mt-3">
                                                <Link to="/sfa-dashboard" className="btn btn-light btn-sm mr-2">
                                                    <i className="fas fa-graduation-cap mr-1"></i>
                                                    SFA Dashboard
                                                </Link>
                                                <Link to="/applications" className="btn btn-light btn-sm">
                                                    <i className="fas fa-clipboard-list mr-1"></i>
                                                    All Applications
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 mb-3">
                                    <div className="card bg-secondary text-white">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fas fa-tachometer-alt mr-2"></i>
                                                Main Dashboard
                                            </h5>
                                            <p className="card-text">Return to the main dashboard</p>
                                            <div className="mt-3">
                                                <Link to="/dashboard" className="btn btn-light btn-sm">
                                                    <i className="fas fa-tachometer-alt mr-1"></i>
                                                    Dashboard
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-info-circle mr-2"></i>
                                                Super Admin Information
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-shield-alt mr-2"></i>Super Admin Privileges</h5>
                                                <p>As a Super Admin, you have full access to:</p>
                                                <ul>
                                                    <li>User management and role assignment</li>
                                                    <li>Permission management</li>
                                                    <li>Form builder and configuration</li>
                                                    <li>System settings</li>
                                                    <li>All reports and analytics</li>
                                                    <li>Application review and management</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    );
}

export default Admin;

